import axios, { AxiosRequestConfig } from "axios";
import { NewsData, ObjectToNewsData } from "../Objects/NewsDate";
import { ApiError } from "./ApiError";

axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = 'X-CSRF-Token';

export interface getNewsDetailListProps {
    page: number
    limit: number
}

export interface getNewsDetailListResults {
    list: NewsData[]
    rows?: number
}

export const getNewsDetailList = async ({
    page,
    limit,
}: getNewsDetailListProps, config?: AxiosRequestConfig): Promise<getNewsDetailListResults> => {
    try {
        let params = new URLSearchParams()
        params.append('page', page.toString())
        params.append('limit', limit.toString())


        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'news/get_news_detail_list',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError("サーバーエラー", res.data.status)
        }
        return {
            list: res.data.list.map((obj: any) => ObjectToNewsData(obj)),
            rows: res.data.rows ? parseInt(res.data.rows) : undefined,
        }
    } catch (error) {
        throw error
    }
}

export interface regNewsReleaseProps {
    news_id: number
    is_push: boolean
}

export const regNewsRelease = async ({
    news_id,
    is_push,
}: regNewsReleaseProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('news_id', news_id.toString())
        params.append('is_push', is_push.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'news/reg_news_release',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError("サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface regNewsLimitProps {
    news_id: number
}

export const regNewsLimit = async ({
    news_id,
}: regNewsLimitProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('news_id', news_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'news/reg_news_limit',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError("サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface delNewsDataProps {
    news_id: number
}

export const delNewsData = async ({
    news_id
}: delNewsDataProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('news_id', news_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'news/del_news_data',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError("サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface regNewsDataProps {
    newsData: NewsData
}

export const regNewsData = async ({
    newsData
}: regNewsDataProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        if (newsData.title) {
            params.append('title', newsData.title)
        }
        if (newsData.news_detail) {
            params.append('news_detail', newsData.news_detail)
        }
        if (newsData.link) {
            params.append('link', newsData.link)
        }
        if (newsData.newsimg_data) {
            let str = newsData.newsimg_data.split(",")
            params.append('newsimg_data', str[1])
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'news/reg_news_data',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError("サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}